/** Photos réelles du 30 août 2026 (export Messenger). Aucune n’est choisie comme photo du bloc. */

export const PREP_PHOTO_CANDIDATES = [
  {
    id: "rocher",
    src: "/media/candidates/rocher.jpg",
    sentBy: "Natalie Lavigne",
    when: "30 août 2026",
    note: "Forêt, quelqu’un debout sur un rocher.",
  },
  {
    id: "clairiere",
    src: "/media/candidates/clairiere.jpg",
    sentBy: "Martine Proulx",
    when: "30 août 2026",
    note: "Quelqu’un dans une éclaircie.",
  },
  {
    id: "marecage",
    src: "/media/candidates/marecage.jpg",
    sentBy: "Natalie Lavigne",
    when: "30 août 2026",
    note: "Quelqu’un dans un sentier humide.",
  },
  {
    id: "portail",
    src: "/media/candidates/portail.jpg",
    sentBy: "Chantal / Luc",
    when: "30 août 2026",
    note: "Portail de bois au territoire.",
  },
  {
    id: "ciel",
    src: "/media/candidates/ciel.jpg",
    sentBy: "Éric Therrien",
    when: "30 août 2026",
    note: "Paysage, ciel et forêt.",
  },
];
